import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '@/views/layout/Layout'

/* Router Modules */

/** note: Submenu only appear when children.length>=1
 *  detail see  https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 **/

/**
* hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
* alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
*                                if not set alwaysShow, only more than one route under the children
*                                it will becomes nested mode, otherwise not show the root menu
* redirect: noredirect           if `redirect:noredirect` will no redirect in the breadcrumb
* name:'router-name'             the name is used by <keep-alive> (must set!!!)
* meta : {
    roles: ['admin','editor']     will control the page roles (you can set multiple roles)
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
    noCache: true                if true ,the page will no be cached(default is false)
  }
**/
export const constantRouterMap = [
  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path*',
        component: () => import('@/views/redirect/index')
      }
    ]
  },
  {
    path: '/heroesRank', // 分销排行榜
    component: () => import('@/views/heroesRank/index'),
    hidden: true
  },
  {
    path: '/dataVisualization', // 数据大屏
    component: () => import('@/views/dataVisualization/index'),
    hidden: true
  },
  {
    path: '/loginAuthorization/:code', // 确认授权页
    component: () => import('@/views/system/LoginAuthorization'),
    name: 'loginAuthorization',
    hidden: true
  },
  {
    path: '/getFile', // 文件管理-查看文件
    component: () => import('@/views/underlyingService/GetFile'),
    hidden: true
  },
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true
  },
  {
    path: '/callback',
    component: () => import('@/views/login/callback'),
    hidden: true
  },
  {
    path: '/auth-redirect',
    component: () => import('@/views/login/authredirect'),
    hidden: true
  },
  {
    path: '/404',
    component: () => import('@/views/errorPage/404'),
    hidden: true
  },
  {
    path: '/401',
    component: () => import('@/views/errorPage/401'),
    hidden: true
  },
  {
    path: '',
    component: Layout,
    hidden: true,
    meta: { title: '首页', icon: 'documentation', noCache: false },
    children: [
      {
        path: '',
        component: () => import('@/views/dashboard/index'),
        name: 'dashboard',
        meta: { title: '首页', icon: 'documentation', noCache: false }
      },
      {
        path: '/toolBox/GeneralQuery/:controllerLabel', // 通用列表 key 代码不同页面的路由自定义名称 controllerLabel
        component: () => import('@/views/toolBox/GeneralQuery'),
        name: 'GeneralQuery',
        hidden: true,
        meta: { title: '报表查询', icon: 'documentation', noCache: false }
      }
      // {
      //   path: '/commonList/:key/:docModel', // 通用列表 key 代码不同页面的路由自定义名称 docModel 即不同页面对应的单据类型 用于调取配置使用
      //   component: () => import('@/views/commonPage/commonList'),
      //   hidden: true
      // }
    ]
  }
  // {
  //   path:'/test',
  //   component:Layout,
  //   hidden:false,
  //   mate:{
  //     title:'test',icon:'documentation',noCache:false
  //   },
  //   children: [
  //     {
  //       path: '',
  //       component: () => import('@/views/svg-icons/index'),
  //       name: 'test',
  //       meta: { title: 'test', icon: 'documentation', noCache: false }
  //     }, ]
  // }
]

export default new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
})

export const asyncRouterMap = [

]
